import React, { useEffect, useState, useRef } from 'react';
// import styles from '../css/DatePicker.css';

const GuestEnquiryDetails = ({ numberOfGuests, firstName, lastName, email, phone, consent, areaMessage, onChange, createEnquiry, isCheckingAvailability }) => {

    const [originalNumberOfGuests, setOriginalNumberOfGuests] = useState(numberOfGuests);
    const [guests, setGuests] = useState('');

    const handleNumberOfGuestsChange = (e) => {
        setGuests(e.target.value);
        if(e.target.value === '')
            onChange('numberOfGuests', originalNumberOfGuests)
        else
            onChange('numberOfGuests', e.target.value)
    }

    const isButtonValid = () => {
        if (guests && firstName && lastName && email && phone) {
            return true;
        }
        return false;
    }

    // const handleGoClick = async () => {
    //     var bookingDate = `${dateInfo.selectedYear}-${(dateInfo.selectedMonth + 1).toString().padStart(2, "0")}-${dateInfo.selectedDay.toString().padStart(2, "0")} ${timeInfo.selectedHour}:${timeInfo.selectedMinute}`;
    //     const request = new Request("/umbraco/Api/Booking/SearchAvailability/?venueId=" + restaurantInfo.liveresId + "&dateTime=" + bookingDate + "&guests=" + guestInfo.numberOfGuests + "&occasion=" + areaInfo.selectedArea);
    //     const response = await fetch(request);
    //     var responseJson = await response.json();
    //     if (responseJson.originalChoiceAvailable) {
    //         onBookingProcessChangeHandler(3)
    //     }
    // }

    return (
        <>
            <style>
                {`
            a {
                text-decoration: underline
            }

            .date-picker {
                position:relative,
                min-height: 42px
            }

            .date-picker-input {
                border: 1px solid #e1e5e9;
                box-sizing: border-box;
                padding-left: 10px;
                padding-top: 5px;
                padding-bottom: 6px;
                min-height: 42px;
                background-color: white;
                width: 10%
            }


            .date-picker-input-disabled {
                border: 1px solid #e1e5e9;
                box-sizing: border-box;
                padding-left: 10px;
                padding-top: 5px;
                padding-bottom: 6px;
                color: silver;
                cursor: default;
                background-color: white;
            }


            .date-picker-dropdown {
                position:absolute;
                background-color:white;
                border:1px solid silver;
                user-select: none;
                z-index:1000;
            }


            .date-picker-year-month-row
            {
                padding:5px;
            }

            .date-picker-previous-month {
                width:25%;
                display:inline-block;
                cursor:pointer;
            }

            .date-picker-current-month {
                width:50%;
                display:inline-block;
                text-align: center;
                font-weight: bold;

            }

            .date-picker-next-month {
                width:25%;
                display:inline-block;
                text-align: right;
                cursor:pointer;
            }

            .date-picker-days {
                display:flex;
                flex-wrap: wrap;
                flex-direction: row;
                padding:5px;
            }

            .date-picker-day {
                width:14.2%;
                font-weight:bold;
                border-bottom:1px dotted silver;
                text-align: center;
            }

            .date-picker-date {
                width:14.2%;
                text-align: center;
            }

            .date-picker-date-disabled {
                color:lightgray !important;
            }

            .date-picker-date-previous-month {
                color:gray;
            }

            .date-picker-date-today {
                color: #00746B;
                font-weight: bold;
            }

            .date-picker-date-selectable {
                cursor:pointer;
            }

            .date-picker-date-selectable:hover {
                background-color:#efefef;    
                border-radius: 15px;
            }

            .date-picker-date-selected {
                background-color: #00746B !important;
                color: white;
                font-weight: bold;
                border-radius: 15px;
            }

            @media only screen and (max-width: 1270px) and (min-width: 901px) {
                .date-picker-next-month,
                .date-picker-previous-month {
                    width: calc(((100vw - 900px)/17) + 10%);
                }
                
                .date-picker-current-month {
                    width: calc(69% - ((100vw - 900px)/18.5));
                    font-size: calc(((100vw - 900px)/74) + 13px);
                }

            }

            @media only screen and (max-width: 767px) {
                .date-picker-dropdown {
                    width: 100vw;
                    position:fixed;
                    left:0;
                }
                
                .date-picker-date {
                    margin-top:5px;
                    margin-bottom:5px;
                }

            }
        `}
            </style>

            <p>For large bookings we need to check with the restaurant before we can book your table. Please fill out the form and we'll get back to you within 4 hours.</p>
            <div className='flex mt-6'>
                <div className='flex flex-col gap-4'>
                    <div className='flex gap-4'>
                        <div>
                            <label>Number of guests</label>
                            <select className='select time-select w-full' onChange={handleNumberOfGuestsChange}>
                            <option value="">Please Select</option>
                            {Array.from({ length: 50 }, (_, index) => index + 1).map((i) => {
                                return <option key={i} value={i}>{i}</option>;
                            })}
                            <option value="50">50+</option>
                            </select>
                            <p>Please include any children you're bringing in your total number of guests. You can tell us if you need a highchair later in the booking process.</p>
                        </div>
                    </div>
                    <div className='flex gap-4'>
                        <div>
                            <label className='label'>First name</label>
                            <input className='input' value={firstName} onChange={(e) => onChange('firstName', e.target.value)}></input>
                        </div>
                        <div className='grow'>
                            <label className='label'>Last name</label>
                            <input className='input' value={lastName} onChange={(e) => onChange('lastName', e.target.value)}></input>
                        </div>
                    </div>
                    <div className='flex gap-4'>
                        <div className='grow'>
                            <label>Email</label>
                            <input value={email} type="email" className='input' onChange={(e) => onChange('email', e.target.value)}></input>
                        </div>
                    </div>
                    <div className='flex gap-4'>
                        <div className='grow'>
                            <label>Phone number</label>
                            <input value={phone} onChange={(e) => onChange('phone', e.target.value)}></input>
                        </div>
                    </div>
                    <div className='flex gap-4'>
                        <div className="flex flex-row gap-4">
                            <input type='checkbox' name="content" id="consent" checked={consent} value={consent} onChange={() => onChange('consent', !consent)} />
                            <label for="consent">We’d love to keep you updated with news and offers about similar products and services. We’ll use the details you’ve provided for this purpose, unless you tell us not to.
                                Untick this box if you do not want to receive marketing communications from us. 
                                For more information, see our <a class="underline" href="https://www.jamiesitalian.co.uk/privacy-policy">Privacy Policy</a>.</label>
                        </div>
                    </div>
                    <div className="mt-4">
                        <button className="button button-secondary" disabled={!isButtonValid() || isCheckingAvailability} onClick={() => createEnquiry()}>
                            <div className='flex flex-[1-1-100%] gap-2 text-center justify-center'>
                                <div>Enquire now</div>
                                {isCheckingAvailability &&
                                    <div className='box-icon flex flex-col justify-center'>
                                        <div className="loader-small"></div>
                                    </div>
                                }
                            </div>
                        </button>
                    </div>
                </div>
            </div>
            {areaMessage && <div>
                <h3>What to know before you go</h3>
                <p>{areaMessage}</p>
            </div>}
        </>);

}

export default GuestEnquiryDetails;